import script from "./Feedback.vue?vue&type=script&lang=ts&setup=true"
export * from "./Feedback.vue?vue&type=script&lang=ts&setup=true"

import "./Feedback.vue?vue&type=style&index=0&id=f161d812&lang=scss"

const __exports__ = script;

export default __exports__